import i18n from "i18next";
import { faClipboardCheck } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { SitePartsPage } from "src/components/views/erp/parts/siteParts/SitePartsPage.tsx";
import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenSitePartButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	partId: number | null | undefined;
}

export const OpenSitePartButton = ({ partId, variant = "menu", ...props }: OpenSitePartButtonProps) => {
	const { openDialog } = useGenericDialog();
	const hasPermission = useHasPermission();
	if (!hasPermission(Permissions.Parts.SiteParts.READ)) return null;
	if (partId == null) return null;

	return (
		<AsyncButton
			label={i18n.t("open_part")}
			icon={faClipboardCheck}
			variant={variant}
			onClick={() => {
				openDialog({
					title: i18n.t("part"),
					agentContext: {
						key: defineAgentUiContextKey("erp.parts.sitePart.openSitePartButton.dialog"),
						data: { partId },
						pathSegments: [`${i18n.t("part")} ${partId}`],
					},
					content: <SitePartsPage sitePartId={partId} />,
				});
			}}
			{...props}
		/>
	);
};
